<template>
  <PriceCustomisationToolTab :product="product" />
</template>

<script lang="ts" setup>
import PriceCustomisationToolTab from '~/components/price-assessments/PriceCustomisationToolTab.vue'
import type { TProduct } from '~/src/types/product.ts'

/*-------------------------------------
    Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
    Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
}>()
</script>
